import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PaymentCheckout, PaymentGatewayData, PGCommissionTransactionPostDto, PGOrderDetDto } from '../@core/interfaces/common/paymentgateway';
import { RolesApi } from '../@core/backend/common/api/roles.api';
import { ToastrAppSrvcService } from './toastr-app-srvc.service';
import { Observable, of,Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { image } from 'html2canvas/dist/types/css/types/image';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayService extends PaymentGatewayData {
  constructor(private api: RolesApi,public toaster: ToastrAppSrvcService) {
    super();
  }

    protected readonly unsubscribe$ = new Subject<void>();

  getOrderIdPayment(data: PGOrderDetDto, tenantId: string, branchId: string): Observable<any> {
    const url = `${environment.baseUrl}/paymentGatewayCommission/PostPGOrderDet?tenantId=${tenantId}&branchId=${branchId}`;
    
    return this.api.add(url, data).pipe(
      map((response: any) => {
        if (!response) {
          this.toaster.ForDanger('Unable to initiate payment. Please try again later.');
          return null;
        }

        if (response?.code === 200) {
          const order_id = response?.detail?.attributes?.id;
          const currency = response?.detail?.attributes?.currency;
          const amount = response?.detail?.attributes?.amount;
          return { order_id, currency, amount }; 
        } else {
          this.toaster.ForDanger('Unable to initiate payment. Please try again later.');
          throw null;
        }
      }),
      catchError((error) => {
          this.toaster.ForDanger('Something went wrong. Please try again later.');
        return of(null); 
      })
    );
  }


    openCheckout(data:PaymentCheckout, onSuccess: (res: any) => void,onFailure:(res:any) => void, onCancel?: () => void): void {
    const options: any = {
      key: data.key,
      amount:data.amount,
      currency:data.currency,
      name: data.name,
      description: data.description,
      order_id: data.orderId,
      image: data.image,
      handler: (response: any) => {
        onSuccess(response);
      },
      modal: {
        ondismiss: () => {
          if (onCancel) onCancel();
        }
      },
      prefill: {
        email: data?.email || null,
        contact:data?.mobile || null
      },
      theme: {
        color: '#3399cc'
      }
    };

    const rzp = new (window as any).Razorpay(options);
    rzp.on('payment.failed', (response: any) => {
      this.toaster.ForDanger('Payment failed. Please try again.');
     if (onFailure) onFailure(response);
    });
    rzp.open();

    
  }


  verifyPaymentSignature(data,tenantId:string,branchId:string): Observable<any> {
    return this.api.add(`${environment.baseUrl}/tenants/${tenantId}/tenantmst/verifySignatureForRazorpay?branchId=${branchId}`, data);
  }


   postCommissionTrans(data:PGCommissionTransactionPostDto):Observable<any> {
    return this.api.add(`${environment.baseUrl}/paymentGatewayCommission/postPGCommissionTrans`, data);
  }

}




